import React from "react";
import { AppList } from "components/list/AppList";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import { CopyField } from "components/fields/CopyField";

import { Datagrid, TextField, ReferenceField, FunctionField } from "react-admin";

import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { DateTimeField } from "../../../components/fields/DateFormatField";

import { ScannerLogContextField } from "./ContextField";
import { ScannerLogsFilter } from "./ListFilters";

const defaultSort = { field: "scanned_at", order: "DESC" };

export const ScannerLogsList = (props) => {
	const { data: globalFilters = {}, isLoading } = useGridUserDataGlobalFiltersContext();
	const { data: terminals } = useTerminalsContext();

	if (isLoading) return null;

	const currentFilters = { terminal_id: globalFilters?.terminal_id };

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<ScannerLogsFilter />}
			filterDefaultValues={currentFilters}
			filter={currentFilters}
		>
			<ScrollingWrapper>
				<Datagrid>
					<TextField source="id" />
					<DateTimeField source="scanned_at" />
					<ReferenceField source="scanned_by" reference="users" link={false} sortable={false}>
						<FunctionField render={(record) => `${record.first_name} ${record.last_name}`} />
					</ReferenceField>
					<TextField source="scanner_name" sortable={false} />
					<FunctionField
						source="scanned_text"
						sortable={false}
						render={(record) => (
							<CopyField value={record.scanned_text} copyByIcon iconPosition="right">
								{record.scanned_text}
							</CopyField>
						)}
					/>
					<FunctionField
						source="context_id"
						label="resources.scanner-logs.fields.context_type"
						sortable={false}
						render={(record) => <ScannerLogContextField record={record} />}
					/>
					<FunctionField
						source="terminal_id"
						sortable={false}
						render={(record) =>
							terminals?.[record?.terminal_id]?.name ?? record?.terminal_id
						}
					/>
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
